import _ from 'underscore';
import type { Middleware } from '../request-with-middleware';

export interface ErrorMiddlewareOptions {
  errorProcessor?: (_error: unknown) => void;
  errorConvertor?: (_responseOrError: unknown) => unknown;
}

export function createErrorMiddleware(
  errorMiddlewareOptions: ErrorMiddlewareOptions = {},
): Middleware {
  const {
    errorProcessor = _.noop,
    errorConvertor: environmentErrorConverter = _.noop,
  } = errorMiddlewareOptions;

  return next => async request => {
    const errorConvertor =
      request.spec.responseContract.errorConvertFn || environmentErrorConverter;
    return next(request).then(response => {
      const error = errorConvertor(response);
      if (error) {
        throw error;
      }
      return response;
    }).catch((error: unknown) => {
      const processedError = errorConvertor(error) || error;
      errorProcessor(processedError);
      throw error;
    });
  };
}
